module.exports = __webpack_public_path__ + "img/chr_ts_2.5f123f84.png";